import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';

import { TIFFViewer } from 'react-tiff';
//import 'react-tiff/dist/index.css';

export default function EmbryoImage(props: any) {
    const { imgItem } = props;

    const img_prefix = "https://mouse.lbl.gov/api/containers/" + imgItem["img_hier"].substring(0,16) + "/image-asset/" + imgItem["img_hier"] + "/";
    const img = img_prefix + "default";
    const thumb = img_prefix + "thumb";
    const download = img_prefix + "download";


    //tmp fix for sections link
    if(imgItem["sections_link"] != null) {
      imgItem["sections_link"] = imgItem["sections_link"].replace("https://enhancer", "https://vista-enhancer");
    }

    const [imageModalopen, setImageModalopen] = useState<any>(false);
    const handleImageModalOpen = () => {
        setImageModalopen(true);
      };
  
  
      const handleImageModalClose = () => {
        setImageModalopen(false);
      };



      /**
       *  
       * Functions to load images from the OLD mouse.lbl.gov API. This will be replaced by the new version very soon.
       *  
       */
    const imageDownloadOldApi = () => {
      if(!imgItem)
        return null;

      let url = imgItem.img_path;
      let ext = imgItem.img_path.split(".");
      ext = ext[ext.length -1];
      let download_filename = "embryo_" + imgItem.exp_embryo + "_img_" + imgItem.image + "." + ext;
      fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = download_filename || "downloaded-file";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error fetching the file:", error);
      });
    };



    const imageBoxOldApi = () => {
      if(!imgItem)
        return null;
      let url = imgItem.img_path;
      let ext = imgItem.img_path.split(".");
      ext = ext[ext.length -1];
      if(ext === "tif"|| ext === "tiff") {
        return(
          <TIFFViewer 
          tiff={url}
          />
        )
      }
      else {
        return(
          <img src={url} alt='' width='500'/>
        )
      }
    };


    const imageViewerOldApi = () => {
      if(!imgItem)
        return null;
      let url = imgItem.img_path+"_thumb.png";
      let ext = imgItem.img_path.split(".");
      ext = ext[ext.length -1];
      if(ext === "jpg"|| ext === "png")
        url = imgItem.img_path;
      let title = "Embryo: "+imgItem.exp_embryo+", Position: "+imgItem.image;
      if(imgItem.is_blue !== "TRUE" && imgItem.is_blue !== 1)
        title += ", Staining: No";
      return(
          <Dialog open={imageModalopen} onClose={handleImageModalClose}>
              <DialogTitle sx={{ m: 0, p: 2 }}>
             {title}
             <IconButton 
                    aria-label="close"
                    onClick={handleImageModalClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton> 
              </DialogTitle>
              <DialogContent>
                {imageBoxOldApi()}
              {/* <img src={url} alt='' width='500'/> */}
              </DialogContent>
              <div className='row mx-1'>
              <div className='col-sm-6 text-left' style={{"fontSize":"12px"}}>{(imgItem.sections_link !== null && imgItem.sections_link !== "")?<div>
                <a href={imgItem.sections_link} target='_blank' rel='noreferrer' className='text-decoration-none btn btn-sm btn-primary'>View Corresponding Sections</a>
              </div>:<></>}</div>
              <div className='col-sm-6 text-end '>
              <span onClick={imageDownloadOldApi} className='btn'><DownloadIcon/></span>
              </div>
              </div>
          </Dialog>
      )
  };


  const embryoImageHandlerOldApi = () => {

    let subtitle = "Pos: "+ imgItem.image;
    if(imgItem.is_blue !== "TRUE" && imgItem.is_blue !== 1) {
      subtitle += ", Staining: No";
    }
    var str_embryo = "Embryo: " + imgItem.exp_embryo;
    var url = imgItem.img_path+"_thumb.png";             
    return (
        <div style={{display:"inline-block", margin:"5px", textAlign:"center", verticalAlign:"top"}}>
                    {str_embryo}  <br/>
                    <i>{subtitle}</i> <br/>
                    {(imgItem.sections_link !== null && imgItem.sections_link !== "")?
                <a href={imgItem.sections_link} target='_blank' rel='noreferrer' className='text-decoration-none' style={{fontSize:"12px"}}>[Sections]</a>
              :<></>}
                    <br/>
                    <button onClick={(event)=>handleImageModalOpen()} style={{border:"0px", padding:"0px"}}><img src={url} width="120" alt={"Embryo No. "+imgItem.exp_embryo}/></button>
                   {imageViewerOldApi()}
                </div>
    );
  };


  /**
   * 
   * Functions using the NEW mouse.lbl.gov image API. These will replace the old one soon.
   * 
   */



    const imageViewer = () => {
      if(!imgItem)
        return null;

      let title = "Embryo: " + imgItem.exp_embryo + ", Position: " + imgItem.image;
      if(imgItem.is_blue !== "TRUE" && imgItem.is_blue !== 1)
        title += ", Staining: No";
      return(
        <Dialog open={imageModalopen} onClose={handleImageModalClose}>
            <DialogTitle sx={{ m: 0, p: 2 }}>
           {title}
           <IconButton 
                  aria-label="close"
                  onClick={handleImageModalClose}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton> 
            </DialogTitle>
            <DialogContent>
            <img src={img} alt='' width='500'/>
            </DialogContent>
            <div className='row mx-1'>
            <div className='col-sm-6 text-left' style={{"fontSize":"12px"}}>{(imgItem.sections_link !== null)?<div>
              <a href={imgItem.sections_link} target='_blank' rel='noreferrer' className='text-decoration-none btn btn-sm btn-primary'>View Corresponding Sections</a>
            </div>:<></>}</div>
            <div className='col-sm-6 text-end '>
            <a href={download} rel='noreferrer' className='btn'><DownloadIcon/></a>
            </div>
            </div>
        </Dialog>
    )
    }


    const embryoImageHandler = () => {

      let subtitle = "Pos: "+ imgItem.image;
      if(imgItem.is_blue !== "TRUE" && imgItem.is_blue !== 1) {
        subtitle += ", Staining: No";
      }
      var str_embryo = "Embryo: " + imgItem.exp_embryo;
      var url = thumb;             
    
      return (
          <div style={{display:"inline-block", margin:"5px", textAlign:"center", verticalAlign:"top"}}>
                      {str_embryo}  <br/>
                      <i>{subtitle}</i> <br/>
                      {(imgItem.sections_link !== null && imgItem.sections_link !== "")?
                <a href={imgItem.sections_link} target='_blank' rel='noreferrer' className='text-decoration-none' style={{fontSize:"12px"}}>[Sections]</a>
              :<></>}
                      <br/>
                      <button onClick={(event)=>handleImageModalOpen()} style={{border:"0px", padding:"0px"}}><img src={url} width="120" alt={"Embryo No. "+imgItem.exp_embryo}/></button>
                     {imageViewer()}
                  </div>
      );
    };

    

    if(!imgItem)
        return null;
    // when new API is deployed, replace with embryoImageHandler
    return(
      //embryoImageHandlerOldApi()
      embryoImageHandler()
    )
}